import { makeStyles } from '@material-ui/core';
import backgroungDemonstracao from "static/cloud21/grouppay/backGroundDemonstracao.png";

const stylesAtivacaoGroupPay = makeStyles({
  titulo: {
    color: "#206C7B", 
    fontWeight: "bold"
  },
  imagemContainer: {
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  imagemBanner: {
    width: "100%",
    height: "100%",
    objectFit: "fill",
  },
  textoDestaque: {
    fontWeight: "bold",
  },
  cardContainer: {
    width: '100%',
    height: '100%',
    padding: 5,
  },
  card: {
    backgroundColor: '#FFFFFF',
    width: '100%',
    height: '100%',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.08)',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icone: {
    padding: 5,
    borderRadius: 5,
  },
  tituloCardPay: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '1.15rem',
    color: '#676A6C',
    paddingBottom: 5,
  },
  contentCard: {
    fontSize: '0.30rem',
    color: '#A3A3A3',
    textAlign: 'center',
  },

  demonstracaoContainer: {
    paddingLeft: 30,
    paddingRight: 30,
  },
  backgroundDemonstracao: {
    backgroundImage: `url(${backgroungDemonstracao})`,
    backgroundPosition: 'center',
    padding: 30,
    width: '100%',
    height: '100%',
  },
  textoContato: {
    textAlign: "center", 
    paddingTop: 20, 
    fontSize: '0.8rem'
  },
  linkEntreEmContato: {
    color: '#888888',
  }
});

export default stylesAtivacaoGroupPay;